import SiteHeader from './components/SiteHeader';
import Hero from './components/Hero';
import TopChart from './components/TopChart';
import MustRead from './components/MustRead';
import Roundup from './components/Roundup';
import Collections from './components/Collections';
import CollectionIndexSection from './components/CollectionIndexSection';
import Faq from './components/Faq';
import CtaBand from './components/CtaBand';
import SiteFooter from './components/SiteFooter';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50 overflow-x-hidden">
      <SiteHeader />
      <main>
        <Hero />
        <TopChart />
        <MustRead />
        <Roundup />
        <Collections />
        <CollectionIndexSection />
        <Faq />
        <CtaBand />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}